export interface IDeliveryFile extends ISelectedImage {
    deliveryFileId: number;
    id: number;
    thumbnailReference?: string;
    storeyId: number;
    storeyFileType: number;
}

export interface IDeliveryExternalFile extends IImageFile {
    planOrderDeliveryFileId: number;
    planOrderExternalFileId: number;
}

export interface IImageFile extends ISelectedImage {
    fileType: string;
    thumbnailReference: string;
}

export interface IDeliveryStorey {
    id: number;
    storey: string;
    customStoreyName: string;
    sketchUpPlan2Ds: IDeliveryFile[];
    sketchUpPlan3Ds: IDeliveryFile[];
    roomSketcherPlan2Ds: IDeliveryFile[];
    roomSketcherPlan3Ds: IDeliveryFile[];
}

export interface IDelivery {
    stories: IDeliveryStorey[];
    externalDeliveryFiles: IDeliveryExternalFile[];
    externalAnnotationFiles: IDeliveryExternalFile[];
    internalExternalFiles: IDeliveryExternalFile[];
}

export interface IFileInfo extends ISelectedImage {
    fileInfoId: number;
}

export interface ISelectedImage {
    filename: string;
    fileReference: string;
}

export interface IStoreyBase {
    id: number;
    storeyId: number;
    files: IFileBase[];
    storeyName: string;
    customStoreyName: string;

    /** Standard storey names */
    availableStories: ISelect[];
}

export interface ISelect {
    id: number;
    name: string;
}

export interface IFileBase {
    id: number;
    filename: string;
    isBlueprint: boolean;
    is2D: boolean;
    is3D: boolean;
    warmStorageReference: string;
    revisions: IRevisionBase[];
    rolename: string;
    parentId: number;
}

export interface IRevisionBase {
    hasAnnotation: boolean;
    warmStorageReference: string;
    filename: string;
    rolename: string;
}

export enum PlanOrderStoreyFileType {
    sketchUp2D = 2,
    sketchUp3D = 3,
    roomSketcher2D = 4,
    roomSketcher3D = 5
}
